import React from 'react'

export const Header = () => {
  return (
    <h2 className="title">
      Expense helper
    </h2>
  )
}
